import { Visibility } from "types/blogs/blogs"
import { NewsStatus } from "types/News"

export const getBlogStatusColors = (status: Visibility) => {
    switch (status) {
        case Visibility.PUBLIC:
            return {
                backgroundColor: '#ECFDF3',
                color: '#027A48',
            }

        case Visibility.DRAFT:
            return {
                backgroundColor: '#F2F4F7',
                color: '#344054',
            }

        case Visibility.SCHEDULED:
            return {
                backgroundColor: '#F8F9FC',
                color: '#363F72',
            }

        case Visibility.ARCHIVED:
            return {
                backgroundColor: '#FFF6ED',
                color: '#C4320A',

            }
        default:
            return {
                backgroundColor: '#F2F4F7',
                color: '#344054',
            }
    }
}

export const getPostStatus = (status: NewsStatus) => {
    switch (status) {
        case NewsStatus.Published:
            return {
                backgroundColor: '#E6F4EA',   // soft green
                color: '#1E7E34',             // deep professional green
            }

        case NewsStatus.Scheduled:
            return {
                backgroundColor: '#E8F1FF',   // soft blue
                color: '#1D4ED8',             // professional blue
            }

        case NewsStatus.UnPublished:
            return {
                backgroundColor: '#F3F4F6',   // neutral gray
                color: '#374151',             // dark gray
            }

        case NewsStatus.Archived:
            return {
                backgroundColor: '#FDECEC',  // soft red
                color: '#D92D20',             // muted red
            }

        default:
            return {
                backgroundColor: '#F3F4F6',
                color: '#374151',
            }
    }
}
